/* unplugin-vue-components disabled */import { render } from "./NotFound.vue?vue&type=template&id=0740937b"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rabbuse/Project/Vue/mian-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__